import { DiagramItemType } from '../../diagram-item-type';

export const DiagramUIStepFunctionItemConfig = {
  type: DiagramItemType.UIStepFunction,
  defaultText: DiagramItemType.UIStepFunction,
  baseType: 'ellipse',
  defaultWidth: 3,
  defaultHeight: 2,
  allowEditText: false
};
